import "../../retro.css";
import { RetroWelcome } from "./RetroWelcome";
import { RetroStatus } from "./RetroStatus";
import { RetroRegister } from "./RetroRegister";
import { RetroClients, RetroFaq } from "./RetroPanels";
import { RetroTaskbar, MENU } from "./RetroTaskbar";
import { useI18n } from "../../lib/i18n";

const DesktopIcons = () => {
  const { t } = useI18n();
  return (
    <nav className="hidden xl:flex flex-col gap-4 pt-2 shrink-0">
      {MENU.map(([id, key, href, Icon]) => (
        <a key={id} href={href} data-testid={`desk-icon-${id}`} className="w98-desk-icon flex flex-col items-center gap-1"
          {...(href.startsWith("http") ? { target: "_blank", rel: "noopener noreferrer" } : {})}>
          <Icon className="h-9 w-9 text-white drop-shadow-[2px_2px_0_rgba(0,0,0,0.5)]" strokeWidth={1.5} />
          <span className="px-1">{t(key)}</span>
        </a>
      ))}
    </nav>
  );
};

export const RetroSite = ({ status, stats, loading, refresh, setTheme }) => (
  <div className="win98 pb-16" data-testid="retro-site">
    <div className="max-w-7xl mx-auto px-3 sm:px-6 py-5 sm:py-8 flex gap-6">
      <DesktopIcons />
      <main className="flex-1 min-w-0 space-y-6">
        <RetroWelcome status={status} />
        <div className="grid lg:grid-cols-5 gap-6 items-start">
          <RetroStatus className="lg:col-span-2" status={status} stats={stats} loading={loading} refresh={refresh} />
          <RetroRegister className="lg:col-span-3" onRegistered={refresh} />
        </div>
        <RetroClients />
        <RetroFaq />
      </main>
    </div>
    <RetroTaskbar status={status} setTheme={setTheme} />
  </div>
);
